import { Close } from '@mui/icons-material';

import {
  StyledDialog,
  StyledDialogTitle,
  TitleText,
  CloseIconButton,
  StyledDialogContent,
  BodyText,
  StyledDialogActions,
  ActionsStack,
  CancelButton,
  ContinueButton,
} from './components';

interface PacerRedirectModalProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
  pacerUrl?: string;
}

export const PacerRedirectModal = ({
  open,
  onClose,
  onContinue,
}: PacerRedirectModalProps) => {
  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <StyledDialogTitle>
        <TitleText variant="h2">
          Leaving BeenVerified to Purchase on PACER
        </TitleText>
        <CloseIconButton aria-label="close" onClick={onClose}>
          <Close />
        </CloseIconButton>
      </StyledDialogTitle>

      <StyledDialogContent>
        <BodyText variant="body1">
          You're about to be redirected to PACER (Public Access to Court
          Electronic Records), the official U.S. federal court system.
        </BodyText>
        <BodyText variant="body1">
          Some court documents are not available for download and must be
          purchased directly through PACER. BeenVerified provides download
          access whenever possible, but if a document hasn't been added to the
          public archive, PACER requires a small fee to download it.
        </BodyText>
        <BodyText variant="body1">
          Even if a free version exists, you may still want to purchase on PACER
          to ensure you're getting the latest and most complete version of the
          filing.
        </BodyText>
      </StyledDialogContent>

      <StyledDialogActions>
        <ActionsStack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <CancelButton variant="outlined" onClick={onClose}>
            Cancel
          </CancelButton>
          <ContinueButton variant="contained" onClick={onContinue}>
            Continue to PACER
          </ContinueButton>
        </ActionsStack>
      </StyledDialogActions>
    </StyledDialog>
  );
};
